var map = {
	"./BottomLeft": 79260,
	"./BottomLeft.jsx": 79260,
	"./BottomRight": 84909,
	"./BottomRight.jsx": 84909,
	"./TopLeft": 64650,
	"./TopLeft.jsx": 64650,
	"./TopRight": 70027,
	"./TopRight.jsx": 70027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1870;